import { FC } from "react"
import cx from "classnames"
import { BiSolidFilePdf } from "react-icons/bi"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const PdfIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <BiSolidFilePdf
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default PdfIcon
